import { gql } from '@apollo/client';
import config from 'config';
const styleIndex = config.algolia.algolia_prefix + 'styles';

export const GET_MY_STYLES = gql`
    query LocationsQuery($query: String!, $filters: String!, $index: string, $hit: Number!, $page: Number!) {
        locationsInRadius
            @algolia(
                __typename: "ALGOLIA_MY_STYLES"
                index: $index
                filters: $filters
                hitsPerPage: $hit
                query: $query
                page: $page
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;

export const GET_STYLE_BY_ID = gql`
    query LocationsQuery($query: String!, $filters: String!) {
        algolia_get_style_by_id
            @algolia(
                __typename: "ALGOLIA_GET_STYLE_BY_ID"
                index: ${styleIndex}
                filters: $filters
                hitsPerPage: 1
                query: $query
                page: 0
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;

export const COUNT_MY_STYLES = gql`
query LocationsQuery ($query : String!, $filters: String!, $hit : Number!, $page : Number!) {
  locationsInRadius @algolia(__typename: "ALGOLIA_COUNT_MY_STYLES", index: ${styleIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;
export const GET_MY_ITEMS = gql`
    query myItems($input: GetItemInput!) {
        myItems(input: $input) {
            data {
                id
                taffiId
                price
                title
                images
                accessLevel
                brand {
                    id
                    name
                    value
                    imageUrl
                }
                itemCodes
                available
                currency
                parentStyle {
                    taffiId
                }
                url
                storeId
            }
            paging {
                size
                page
            }
        }
    }
`;
export const GET_STYLE_DETAIL = gql`
    query getStyle($input: GetStyleInput!) {
        getStyle(input: $input) {
            data {
                id
                creator
                taffiId
                price
                currency
                title
                description
                collection
                consumers {
                    id
                    firstName
                    lastName
                }
                consumersId
                images
                personas {
                    id
                    title
                    value
                }
                imageJson
                genders {
                    id
                    title
                    value
                }
                user {
                    id
                    email
                    gender
                    firstName
                    lastName
                    userName
                    level {
                        title
                        value
                        imageUrl
                    }
                    bio
                    profileImageUrl
                    approved
                    availableForStylingSessions
                }
                purposes {
                    id
                    title
                    value
                }
                ages {
                    id
                    title
                    value
                }
                bodyShapes {
                    id
                    title
                    value
                }
                bodyTypes {
                    id
                    title
                    value
                }
                seasons {
                    id
                    title
                    value
                }
                categories {
                    id
                    name
                }
                tags {
                    id
                    name
                }
                labels {
                    id
                    name
                }
                items {
                    id
                    data {
                        localId
                        creator
                        colors {
                            id
                            title
                            value
                            subject
                        }
                        sizes {
                            id
                            title
                            value
                            subject
                        }
                        id
                        taffiId
                        collection
                        price
                        currency
                        available
                        title
                        description
                        categories {
                            id
                            name
                        }
                        tags {
                            id
                            name
                        }
                        labels {
                            id
                            name
                        }
                        url
                        images
                        accessLevel
                        brand {
                            id
                            name
                            value
                            imageUrl
                        }
                        storeId
                        storeProductId
                        store {
                            id
                            name
                            platform
                            shopifyDomain
                            taffiId
                            url
                        }
                        user {
                            approved
                            availableForStylingSessions
                            firstName
                            lastName
                            profileImageUrl
                            gender
                            userName
                        }
                        metadata {
                            category
                            imageMetadata
                        }
                        backgroundRemovedMap {
                            originalUrl
                            backgroundRemovedUrl
                            width
                            height
                            xmin
                            xmax
                            ymin
                            ymax
                        }
                    }
                    variant {
                        color
                        size
                    }
                }
                status
                sourceId
            }
            paging {
                size
                page
            }
        }
    }
`;
export const GET_USER_STYLE = gql`
    query getUserStyle {
        getUserStyle {
            id
            styleGuideUrl
        }
    }
`;

export const GET_USER_STYLE_GUIDE_BY_USERNAME = gql`
    query GetUserStyleByUserName($input: GetUserStyleByUserNameInput!) {
        getUserStyleByUserName(input: $input) {
            id
            styleGuideUrl
        }
    }
`;

export const GET_REJECTED_STYLES = gql`
    query GetRejectedStyles($input: GetRejectedStylesInput!) {
        getRejectedStyles(input: $input) {
            data
            paging {
                page
                size
            }
        }
    }
`;

export const GET_RECOMMENDATIONS = gql`
    mutation getRecommendations($input: GetRecommendationsInput!) {
        getRecommendations(input: $input) {
            recommendations {
                ... on RecommendationsStyle {
                    id
                    taffiId
                    title
                    description
                    images
                    imageJson
                    user
                    purposes
                    seasons
                    items
                    itemsId
                    sourceId
                    sourceTaffiId
                    status
                    collectionName
                }
                ... on RecommendationsItem {
                    id
                    taffiId
                    title
                    url
                    description
                    images
                    user
                    status
                    backgroundRemovedMap
                    metadata
                    collectionName
                }
            }
            styleAdvice
            info
            primaryItem
        }
    }
`;
